import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import {
  GetDeviceEventsQueryParams,
  GetDeviceEventsResponse,
} from './deviceEvents.types';

export const getDeviceEventsAPI = async ({
  params,
}: {
  params: GetDeviceEventsQueryParams;
}): Promise<AxiosResponse<GetDeviceEventsResponse & ApiError>> => {
  return instance
    .get<GetDeviceEventsResponse>('/device-events', {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
